import React, { useState } from "react";
import { Modal } from "../components/AsyncConfirm";

export function useAsyncConfirm() {
    const [modalConfig, setModalConfig] = useState<{
        message: string,
        isAlert?: boolean,
        resolve: (val: boolean) => void
    } | null>(null);

    const askUser = (message: string): Promise<boolean> => {
        return new Promise((resolve) => {
            setModalConfig({ message, resolve,isAlert:false });
        });
    };

    const notify = (message: string): Promise<boolean> => {
        return new Promise((resolve) => {
            setModalConfig({ message, resolve, isAlert: true });
        });
    };

    const ConfirmComponent = modalConfig ? (
        <Modal 
            message={modalConfig.message}
            isAlert={modalConfig.isAlert}
            onConfirm={() => { modalConfig.resolve(true); setModalConfig(null); }}
            onCancel={() => { modalConfig.resolve(false); setModalConfig(null); }}
        />
    ) : null;

    return { askUser, notify,ConfirmComponent };
}